export default function HistoryEmpty() {
  return (
    <div
      data-testid="history-empty"
      className="bg-white border border-border/60 rounded-2xl shadow-sm p-16 text-center"
    >
      <div className="font-heading text-2xl tracking-tight mb-2">No lookups yet</div>
      <div className="text-sm text-[#5B695E]">
        Run a parcel lookup to start building your search history.
      </div>
    </div>
  );
}
